module.exports = __webpack_public_path__ + "img/cm.bae00c60.jpg";